export default __webpack_public_path__ + "static/media/page17.34450241.webp";